import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function DisplayFooterTime() {
  const { defaultTimeFormat } = useSelector((store) => store.app);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const timeFormat =
    defaultTimeFormat?.withoutSecond === 'HH:mm' ? 'HH:mm:ss' : 'hh:mm:ss a';
  const formattedTime = format(
    currentTime,
    `EEEE MMMM d, yyyy | ${timeFormat}`
  );

  return <div>{formattedTime}</div>;
}

export default DisplayFooterTime;
